import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "BundleName" */ './lazyIndex');
});
export var LeftnavUpsell = createLazyComponent(lazyModule, function (m) { return m.LeftnavUpsell; });
//# sourceMappingURL=index.js.map